export const messages = {
  en: {
    storeOrderCartFee: {
      queryTitle: 'Query Conditions',
      orderFeeTitle: 'Order Fee',
      orderIdPlaceholder: 'Please enter order number',
      feeNamePlaceholder: 'Please enter fee name',
      cartIdPlaceholder: 'Please enter sub order number',
      statePlaceholder: 'Please select status',
      orderId: 'Order Number',
      cartId: 'Sub Order Number',
      feeName: 'Fee Name',
      price: 'Amount',
      payPrice: 'Payment Amount',
      couponDiscount: 'Coupon Discount',
      payWayName: 'Payment Method',
      state: 'Status',
      updateTime: 'Payment Time',
      remark: 'Remark',
      unpaid: 'Unpaid',
      paid: 'Paid'
    }
  },
  zh: {
    storeOrderCartFee: {
      queryTitle: '查询条件',
      orderFeeTitle: '订单费用',
      orderIdPlaceholder: '请输入订单号',
      feeNamePlaceholder: '请输入费用名称',
      cartIdPlaceholder: '请输入子订单号',
      statePlaceholder: '请选择状态',
      orderId: '订单号',
      cartId: '子订单号',
      feeName: '费用名称',
      price: '金额',
      payPrice: '支付金额',
      couponDiscount: '优惠券抵扣',
      payWayName: '支付方式',
      state: '状态',
      updateTime: '支付时间',
      remark: '备注',
      unpaid: '未支付',
      paid: '已支付'
    }
  }
}